var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Spinner/index.tsx";
import React from 'react';
import { LoadingSpinner, VStack } from '@adc/parallax-component-library';
const Spinner = ({
  testID = ''
}) => {
  return /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    backgroundColor: "$surface.background",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
    style: {
      height: '100vh',
      width: '100vw'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    testID: `${testID}.spinner`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 7
    }
  }));
};
export { Spinner };